import { render, staticRenderFns } from "./SpacePagePrivacyPopover.vue?vue&type=template&id=13151ce6&scoped=true"
import script from "./SpacePagePrivacyPopover.js?vue&type=script&lang=js&external"
export * from "./SpacePagePrivacyPopover.js?vue&type=script&lang=js&external"
import style0 from "./SpacePagePrivacyPopover.scss?vue&type=style&index=0&id=13151ce6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13151ce6",
  null
  
)

export default component.exports